import {difference, keys, omit, keyBy, createReducer} from 'helpers';
import {RootState, Actions} from 'store/types';
import {ServerActions} from 'store/server';
import * as actions from '../actions/actions';

export const types = createReducer<RootState['notes']['types'], Actions<typeof actions> | ServerActions>({}, {
  NOTES_UPDATE: (state, {note, category}) => {
    if (!category.predefined && !state[category.id]) {
      return {
        ...state,
        [category.id]: {
          id: category.id,
          name: note.category
        }
      };
    }
    return state;
  },

  NOTES_CATEGORY_UPDATE: (state, {name, id}) => {
    if (name.trim() && id) {
      return {
        ...state,
        [id]: {id, name}
      };
    }
    return state;
  },

  NOTES_CATEGORY_DELETE: (state, {id}) => {
    return omit(state, id);
  },

  NOTES_TEXT_UPDATE: (state) => state,

  NOTES_DELETE: (state) => state,

  SERVER_DATA_RECEIVED: (state, {existingElementIds, noteTypes}) => {
    const removed = difference(keys(state), existingElementIds.noteTypes);
    if (noteTypes.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(noteTypes, 'id')
      }, removed);
    }
    return state;
  },

  SERVER_DATA_RECEIVED_AFTER: (state) => state,

  TESTING_DELETE_ALL: () => ({}),

});
